"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./types");
const colors_1 = __importDefault(require("./colors"));
const fontSizes_1 = __importDefault(require("./fontSizes"));
const spaces_1 = __importDefault(require("./spaces"));
const icons_1 = __importDefault(require("./icons"));
const thTheme = {
    link: {
        uiPrimary: {
            cursor: 'pointer',
            background: 'transparent',
            color: colors_1.default.redWeb,
            display: 'flex',
            paddingLeft: 0,
            paddingRight: 0,
            '.icon': {
                marginRight: spaces_1.default[2],
            },
            '.link-text': {
                display: 'flex',
                color: colors_1.default.redWeb,
                position: 'relative',
                paddingBottom: '10px',
                alignItems: 'center',
                lineHeight: '22px',
                '&::after': {
                    position: 'absolute',
                    bottom: '6px',
                    left: 0,
                    display: 'block',
                    height: '2px',
                    content: '""',
                    width: '100%',
                    backgroundColor: colors_1.default.redWeb,
                    opacity: 0.2,
                    transition: '0.2s ease-in',
                },
                '&::before': {
                    position: 'absolute',
                    bottom: '6px',
                    left: 0,
                    display: 'block',
                    height: '2px',
                    content: '""',
                    width: '2px',
                    backgroundColor: colors_1.default.redWeb,
                },
                '&:hover': {
                    '&::after': {
                        opacity: 1,
                    },
                },
            },
            '&:hover,&:focus,&:active': {
                textDecoration: 'none',
                '.link-text': {
                    color: colors_1.default.redHover,
                    '&::after': {
                        opacity: 1,
                        backgroundColor: colors_1.default.redHover,
                    },
                },
                '.icon': {
                    color: colors_1.default.redHover,
                },
                '&:active': {
                    color: colors_1.default.redActive,
                    '.icon': {
                        color: colors_1.default.redActive,
                    },
                },
            },
        },
        uiDefault: {
            cursor: 'pointer',
            color: colors_1.default.black,
            textDecoration: 'underline',
            '.link-text': {
                color: colors_1.default.black,
                lineHeight: '22px',
            },
            '&:hover,&:focus,&:active': {
                color: colors_1.default.redHover,
                '.link-text': {
                    color: colors_1.default.redHover,
                },
                '&:active': {
                    color: colors_1.default.redActive,
                    '.link-text': {
                        color: colors_1.default.redActive,
                    },
                },
            },
        },
        uiWhite: {
            cursor: 'pointer',
            background: 'transparent',
            color: colors_1.default.white,
            display: 'flex',
            paddingLeft: 0,
            paddingRight: 0,
            '.icon': {
                marginRight: spaces_1.default[2],
            },
            '.link-text': {
                display: 'flex',
                color: colors_1.default.white,
                position: 'relative',
                paddingBottom: '10px',
                alignItems: 'center',
                lineHeight: '22px',
                '&::after': {
                    position: 'absolute',
                    bottom: '6px',
                    left: 0,
                    display: 'block',
                    height: '2px',
                    content: '""',
                    width: '100%',
                    backgroundColor: colors_1.default.white,
                    opacity: 0.2,
                    transition: '0.2s ease-in',
                },
                '&::before': {
                    position: 'absolute',
                    bottom: '6px',
                    left: 0,
                    display: 'block',
                    height: '2px',
                    content: '""',
                    width: '2px',
                    backgroundColor: colors_1.default.white,
                },
                '&:hover': {
                    '&::after': {
                        opacity: 1,
                    },
                },
            },
            '&:hover,&:focus,&:active': {
                textDecoration: 'none',
                '.link-text': {
                    '&::after': {
                        opacity: 1,
                    },
                },
                '.icon': {
                    color: colors_1.default.white,
                },
                '&:active': {
                    color: colors_1.default.redActive,
                    '.link-text': {
                        color: colors_1.default.redActive,
                        '&::after': {
                            opacity: 1,
                            backgroundColor: colors_1.default.redActive,
                        },
                    },
                    '.icon': {
                        color: colors_1.default.redActive,
                    },
                },
            },
        },
    },
    button: {
        uiPrimary: {
            backgroundColor: colors_1.default.redWeb,
            color: colors_1.default.white,
            fontSize: fontSizes_1.default[1],
            padding: `10px ${spaces_1.default[4]}`,
            boxShadow: `0px 0px 0px ${colors_1.default.redWeb}`,
            border: `2px solid ${colors_1.default.redWeb}`,
            borderRadius: '5px',
            textAlign: 'center',
            '&:focus': {
                backgroundColor: colors_1.default.redActive,
                border: `2px solid ${colors_1.default.redActive}`,
                textDecoration: 'underline',
            },
            '&:hover': {
                backgroundColor: colors_1.default.redHover,
                border: `2px solid ${colors_1.default.redHover}`,
                textDecoration: 'underline',
            },
            '&:active': {
                backgroundColor: colors_1.default.redActive,
                border: `2px solid ${colors_1.default.redActive}`,
                textDecoration: 'underline',
            },
            '&:disabled, &.disabled': {
                backgroundColor: colors_1.default.lightGrey,
                border: `2px solid ${colors_1.default.lightGrey}`,
                color: colors_1.default.darkGrey,
            },
        },
        uiSecondary: {
            backgroundColor: colors_1.default.white,
            color: colors_1.default.redWeb,
            fontSize: fontSizes_1.default[1],
            padding: `10px ${spaces_1.default[4]}`,
            boxShadow: `0px 0px 0px ${colors_1.default.redWeb}`,
            border: `2px solid ${colors_1.default.redWeb}`,
            borderRadius: '5px',
            textAlign: 'center',
            '&:focus': {
                backgroundColor: colors_1.default.redActive,
                border: `2px solid ${colors_1.default.redActive}`,
                textDecoration: 'underline',
            },
            '&:hover': {
                backgroundColor: colors_1.default.redHover,
                border: `2px solid ${colors_1.default.redHover}`,
                textDecoration: 'underline',
            },
            '&:active': {
                backgroundColor: colors_1.default.redActive,
                border: `2px solid ${colors_1.default.redActive}`,
                textDecoration: 'underline',
            },
            '&:disabled, &.disabled': {
                backgroundColor: colors_1.default.lightGrey,
                border: `2px solid ${colors_1.default.lightGrey}`,
                color: colors_1.default.darkGrey,
            },
        },
        uiPrimaryDark: {
            backgroundColor: colors_1.default.white,
            color: colors_1.default.redWeb,
            fontSize: fontSizes_1.default[1],
            padding: `10px ${spaces_1.default[4]}`,
            boxShadow: `0px 0px 0px ${colors_1.default.redWeb}`,
            border: `2px solid ${colors_1.default.white}`,
            borderRadius: '5px',
            textAlign: 'center',
            '&:focus': {
                border: `2px solid ${colors_1.default.redHover}`,
                color: colors_1.default.redHover,
                textDecoration: 'underline',
            },
            '&:hover': {
                borderColor: 'none',
                color: colors_1.default.redHover,
                textDecoration: 'underline',
            },
            '&:active': {
                backgroundColor: colors_1.default.roseFine,
                border: `2px solid ${colors_1.default.roseFine}`,
                color: colors_1.default.redActive,
                textDecoration: 'underline',
            },
            '&:disabled, &.disabled': {
                backgroundColor: colors_1.default.lightGrey,
                border: `2px solid ${colors_1.default.lightGrey}`,
                color: colors_1.default.darkGrey,
            },
        },
        uiSecondaryDark: {
            backgroundColor: 'transparent',
            color: colors_1.default.white,
            fontSize: fontSizes_1.default[1],
            padding: `10px ${spaces_1.default[4]}`,
            boxShadow: `0px 0px 0px ${colors_1.default.redWeb}`,
            border: `2px solid ${colors_1.default.white}`,
            borderRadius: '5px',
            textAlign: 'center',
            '&:focus, &:hover': {
                textDecoration: 'underline',
                border: `2px solid ${colors_1.default.redHover}`,
                color: colors_1.default.redHover,
            },
            '&:hover': {
                borderColor: 'none',
            },
            '&:active': {
                backgroundColor: colors_1.default.roseFine,
                border: `2px solid ${colors_1.default.roseFine}`,
                color: colors_1.default.redActive,
                textDecoration: 'underline',
            },
            '&:disabled, &.disabled': {
                backgroundColor: colors_1.default.lightGrey,
                border: `2px solid ${colors_1.default.lightGrey}`,
                color: colors_1.default.darkGrey,
            },
        },
        uiIconBtn: {
            backgroundColor: 'transparent',
            padding: spaces_1.default[1],
            fontSize: '0px',
            color: 'inherit',
            letterSpacing: 'initial',
            lineHeight: 1.3,
            svg: {
                margin: 0,
            },
        },
        uiLinkBtn: {
            background: 'transparent',
            color: colors_1.default.redWeb,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingLeft: 0,
            paddingRight: 0,
            '.icon-link': {
                marginRight: spaces_1.default[3],
            },
            '.text-link, .load-more-text': {
                display: 'flex',
                color: colors_1.default.redWeb,
                position: 'relative',
                paddingBottom: '10px',
                alignItems: 'center',
                lineHeight: '22px',
                '&::after': {
                    position: 'absolute',
                    bottom: '6px',
                    left: 0,
                    display: 'block',
                    height: '2px',
                    content: '""',
                    width: '100%',
                    backgroundColor: colors_1.default.redWeb,
                    opacity: 0.2,
                    transition: '0.2s ease-in',
                },
                '&::before': {
                    position: 'absolute',
                    bottom: '6px',
                    left: 0,
                    display: 'block',
                    height: '2px',
                    content: '""',
                    width: '2px',
                    backgroundColor: colors_1.default.redWeb,
                },
                '&:hover': {
                    '&::after': {
                        opacity: 1,
                    },
                },
            },
            '&:hover,&:focus,&:active': {
                textDecoration: 'none',
                '.text-link, .load-more-text': {
                    color: colors_1.default.redHover,
                    '&::after': {
                        opacity: 1,
                    },
                    '.icon': {
                        fill: colors_1.default.redHover,
                    },
                },
                '&:active': {
                    color: colors_1.default.redActive,
                    '.icon': {
                        fill: colors_1.default.redActive,
                    },
                },
            },
        },
    },
    icons: icons_1.default,
};
exports.default = thTheme;
//# sourceMappingURL=index.js.map